export const BUSY_TYPES = {
    LOAD: "load",
    SAVE: "save"
};